/* eslint-disable */
export default {
  createCallLog: '创建通话记录',
  viewInSalesforce: '在 Salesforce 中查看',
  createLog: '创建记录',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
